import { gql } from '@apollo/client';

export const postPaquetesNyPSP = gql`
mutation  PaquetesNyPSPApiRQ{
     PaquetesNyPSPApiRQ(input: $input)  
        @rest(type: " PaquetesNyPSPApiRS", path: "/api/gateway/formularios/PaqueteNegocios", method: "POST"){
            nroSolicitud
            nroSecuencia
            resultado
            error
            stackTrace
        }
}
`